import { Outlet, ScrollRestoration } from "react-router-dom";
import '../global.css';
import { Helmet } from "react-helmet-async";
import { useTheme } from "@/theme/ThemeProvider";
import { useEffect, useState } from "react";

import { AppFooterLayout } from "./AppFooterLayout";
import { AppHeaderModelo2Layout } from "./AppHeaderModelo2Layout";
import { Toaster } from "@/components/ui/toaster";
import { titulosDeCapitalizacao } from "@/utils/copyTituloBilhete";

export function AppLayout() {
    const { theme } = useTheme();
    const [helmetTitle, setHelmetTitle] = useState('');

    useEffect(() => {
        const sufixo = titulosDeCapitalizacao();
        switch (theme) {
            case 'RondonCap':
                setHelmetTitle(`RondônCap | ${sufixo}`)
                break;
            case 'MegaCap':
                setHelmetTitle(`MegaCap | ${sufixo}`)
                break;
            case 'RoraiCap':
                setHelmetTitle(`RoraiCap | ${sufixo}`)
                break;
            case 'AcreCap':
                setHelmetTitle(`AcreCap | ${sufixo}`)
                break;

            default:
                break;
        }
    }, [theme])

    return (
        <div >
            <Toaster />
            <Helmet title={helmetTitle} />
            <AppHeaderModelo2Layout />
            <div className="min-h-96 lg:px-36 2xl:px-96">
                <ScrollRestoration getKey={location => location.pathname} />
                <Outlet />
            </div>
            <AppFooterLayout />
        </div>
    )
}